// extracted by mini-css-extract-plugin
export default {"olu_Container":"Olu_olu_Container__5qXj+","olu_Wrapper":"Olu_olu_Wrapper__0RHcH","olu_Link":"Olu_olu_Link__eqbET"};